import { useState, useEffect, useRef } from 'react';
import { getCareers } from '../services/api';
import Header from '../components/Header';

const dummyCareers = [
  {
    id: 1,
    title: 'Mechanical Engineer',
    slug: 'mechanical-engineer',
    department: 'Engineering',
    location: 'Balikpapan',
    type: 'Full-time',
    description: '<p>Kami mencari Mechanical Engineer berpengalaman untuk bergabung dengan tim engineering kami. Anda akan bertanggung jawab dalam perancangan, analisis, dan pengembangan komponen mekanik untuk alat berat.</p><ul><li>Merancang dan mengembangkan komponen mekanik</li><li>Melakukan analisis kekuatan material</li><li>Berkolaborasi dengan tim produksi</li><li>Membuat dokumentasi teknis</li></ul>',
    requirements: '<ul><li>S1 Teknik Mesin dari universitas terakreditasi</li><li>Pengalaman minimal 3 tahun di bidang manufaktur</li><li>Menguasai AutoCAD, SolidWorks, atau software CAD lainnya</li><li>Memahami proses machining dan fabrikasi</li><li>Kemampuan komunikasi yang baik</li><li>Bersedia ditempatkan di Balikpapan</li></ul>',
    benefits: '<ul><li>Gaji kompetitif</li><li>BPJS Kesehatan & Ketenagakerjaan</li><li>Tunjangan transportasi</li><li>Pelatihan dan pengembangan karir</li><li>Lingkungan kerja profesional</li></ul>',
    salary_range: 'Rp 10.000.000 - Rp 15.000.000',
    deadline: '2026-06-30',
    is_active: true,
    sort_order: 0,
  },
  {
    id: 2,
    title: 'CNC Operator',
    slug: 'cnc-operator',
    department: 'Production',
    location: 'Balikpapan',
    type: 'Full-time',
    description: '<p>Dibutuhkan CNC Operator yang terampil untuk mengoperasikan mesin CNC milling dan turning dalam proses remanufacturing komponen alat berat.</p><ul><li>Mengoperasikan mesin CNC milling dan turning</li><li>Membaca dan menginterpretasi gambar teknik</li><li>Melakukan setup mesin dan tooling</li><li>Quality control hasil machining</li></ul>',
    requirements: '<ul><li>SMK/D3 Teknik Mesin atau setara</li><li>Pengalaman minimal 2 tahun sebagai CNC Operator</li><li>Mampu membaca gambar teknik</li><li>Menguasai G-Code dan M-Code</li><li>Teliti dan detail oriented</li><li>Bersedia bekerja shift</li></ul>',
    benefits: '<ul><li>Gaji pokok + lembur</li><li>BPJS Kesehatan & Ketenagakerjaan</li><li>Makan siang</li><li>Seragam kerja</li><li>Bonus tahunan</li></ul>',
    salary_range: 'Rp 6.000.000 - Rp 9.000.000',
    deadline: '2026-06-15',
    is_active: true,
    sort_order: 1,
  },
  {
    id: 3,
    title: 'Quality Control Inspector',
    slug: 'quality-control-inspector',
    department: 'Quality Assurance',
    location: 'Balikpapan',
    type: 'Full-time',
    description: '<p>Bergabunglah sebagai QC Inspector untuk memastikan setiap produk remanufacturing kami memenuhi standar kualitas tertinggi.</p><ul><li>Inspeksi komponen sebelum dan sesudah proses</li><li>Menggunakan alat ukur presisi (CMM, micrometer, dll)</li><li>Membuat laporan inspeksi</li><li>Koordinasi dengan tim produksi terkait kualitas</li></ul>',
    requirements: '<ul><li>D3/S1 Teknik Mesin atau Teknik Industri</li><li>Pengalaman minimal 2 tahun di QC manufaktur</li><li>Menguasai alat ukur presisi</li><li>Memahami standar ISO 9001</li><li>Mampu membaca gambar teknik</li><li>Detail oriented dan analitis</li></ul>',
    benefits: '<ul><li>Gaji kompetitif</li><li>Asuransi kesehatan</li><li>Tunjangan sertifikasi</li><li>Jenjang karir jelas</li><li>Training berkala</li></ul>',
    salary_range: 'Rp 7.000.000 - Rp 11.000.000',
    deadline: '2026-07-01',
    is_active: true,
    sort_order: 2,
  },
];

const Careers = () => {
  const [careers, setCareers] = useState(dummyCareers);
  const [loading, setLoading] = useState(false);
  const [selectedCareer, setSelectedCareer] = useState(null);

  useEffect(() => {
    const fetchCareers = async () => {
      try {
        const data = await getCareers();
        if (data && data.length > 0) {
          setCareers(data);
        }
      } catch (err) {
        console.error('Failed to fetch careers:', err);
      }
      setLoading(false);
    };
    fetchCareers();
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return null;
    return new Date(dateStr).toLocaleDateString('id-ID', {
      day: 'numeric', month: 'long', year: 'numeric'
    });
  };

  const isExpired = (deadline) => {
    if (!deadline) return false;
    return new Date(deadline) < new Date();
  };

  // Scroll reveal observer
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.1, rootMargin: '0px 0px -30px 0px' }
    );
    const els = sectionRef.current?.querySelectorAll('.rv');
    if (els) els.forEach(el => observer.observe(el));
    return () => { if (els) els.forEach(el => observer.unobserve(el)); };
  }, [careers, selectedCareer]);

  return (
    <section id="careers" ref={sectionRef}>
      <div className="wrap">
        <Header />
        <div className="careers-header rv">
          <div className="slide-index" style={{color:'var(--yd)'}}><span></span> Join Our Team</div>
          <h2 className="heading">
            Build Your <em>Career</em><br />
            <span className="outline">With Us</span>
          </h2>
          <p className="careers-subtitle">
            Bergabunglah dengan tim PT CITRA HERITAGE INDONESIA dan jadilah bagian dari industri manufaktur terdepan di Indonesia.
          </p>
        </div>

        {/* Stats */}
        <div className="careers-stats rv">
          <div className="cs-item">
            <span className="cs-num">{careers.length}</span>
            <span className="cs-label">Posisi Tersedia</span>
          </div>
          <div className="cs-item">
            <span className="cs-num">
              {[...new Set(careers.map(c => c.department).filter(Boolean))].length}
            </span>
            <span className="cs-label">Departemen</span>
          </div>
          <div className="cs-item">
            <span className="cs-num">
              {[...new Set(careers.map(c => c.location).filter(Boolean))].length}
            </span>
            <span className="cs-label">Lokasi</span>
          </div>
        </div>

        {/* Content */}
        {loading ? (
          <div className="careers-loading">
            <div className="careers-spinner"></div>
            <p>Memuat lowongan...</p>
          </div>
        ) : careers.length === 0 ? (
          <div className="careers-empty rv">
            <div className="ce-icon">📋</div>
            <h3>Belum Ada Lowongan Tersedia</h3>
            <p>Saat ini belum ada posisi yang dibuka. Silakan cek kembali nanti atau kirimkan CV Anda ke email kami.</p>
            <a href="mailto:hr@afsreman.com" className="btn btn-y">Kirim CV →</a>
          </div>
        ) : (
          <div className="careers-content">
            {/* Job List */}
            <div className="careers-list rv">
              {careers.map((career, idx) => (
                <div
                  key={career.id || idx}
                  className={`career-card ${selectedCareer?.id === career.id ? 'active' : ''} ${isExpired(career.deadline) ? 'expired' : ''}`}
                  onClick={() => setSelectedCareer(career)}
                >
                  <div className="cc-left">
                    <div className="cc-index">
                      {String(idx + 1).padStart(2, '0')}
                    </div>
                    <div className="cc-info">
                      <h3 className="cc-title">{career.title}</h3>
                      <div className="cc-meta">
                        {career.department && (
                          <span className="cc-tag">{career.department}</span>
                        )}
                        {career.location && (
                          <span className="cc-tag">{career.location}</span>
                        )}
                        {career.type && (
                          <span className="cc-tag cc-tag-type">{career.type}</span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="cc-right">
                    {career.deadline && (
                      <span className={`cc-deadline ${isExpired(career.deadline) ? 'expired' : ''}`}>
                        {isExpired(career.deadline) ? 'Ditutup' : `Deadline: ${formatDate(career.deadline)}`}
                      </span>
                    )}
                    <span className="cc-arrow">→</span>
                  </div>
                </div>
              ))}
            </div>

            {/* Job Detail */}
            {selectedCareer && (
              <div className="career-detail rv">
                <div className="cd-header">
                  <button className="cd-close" onClick={() => setSelectedCareer(null)}>✕</button>
                  <h2 className="cd-title">{selectedCareer.title}</h2>
                  <div className="cd-meta-row">
                    {selectedCareer.department && (
                      <span className="cd-badge">🏢 {selectedCareer.department}</span>
                    )}
                    {selectedCareer.location && (
                      <span className="cd-badge">📍 {selectedCareer.location}</span>
                    )}
                    {selectedCareer.type && (
                      <span className="cd-badge">⏰ {selectedCareer.type}</span>
                    )}
                    {selectedCareer.salary_range && (
                      <span className="cd-badge">💰 {selectedCareer.salary_range}</span>
                    )}
                  </div>
                  {selectedCareer.deadline && (
                    <p className="cd-deadline">
                      Batas Lamaran: <strong>{formatDate(selectedCareer.deadline)}</strong>
                    </p>
                  )}
                </div>

                <div className="cd-body">
                  {selectedCareer.description && (
                    <div className="cd-section">
                      <h4>Deskripsi Pekerjaan</h4>
                      <div dangerouslySetInnerHTML={{ __html: selectedCareer.description }} />
                    </div>
                  )}
                  {selectedCareer.requirements && (
                    <div className="cd-section">
                      <h4>Persyaratan</h4>
                      <div dangerouslySetInnerHTML={{ __html: selectedCareer.requirements }} />
                    </div>
                  )}
                  {selectedCareer.benefits && (
                    <div className="cd-section">
                      <h4>Benefit</h4>
                      <div dangerouslySetInnerHTML={{ __html: selectedCareer.benefits }} />
                    </div>
                  )}
                </div>

                <div className="cd-footer">
                  <a
                    href={`mailto:hr@afsreman.com?subject=Lamaran: ${selectedCareer.title}`}
                    className="btn btn-y"
                  >
                    Lamar Sekarang →
                  </a>
                  <a
                    href={`https://wa.me/6281234567890?text=Halo, saya tertarik dengan posisi ${selectedCareer.title}`}
                    className="btn btn-dark"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    WhatsApp HR
                  </a>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default Careers;